import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const SEXO_MAP = { M: 'masculino', F: 'femenino', X: 'noEspecificado' };

// Formato no oficial (reverse-engineered), separado por '@':
// tramite@apellidos@nombres@sexo@dni@ejemplar@fechaNacimiento@fechaEmision@cuil
export function parseDniPdf417(text) {
  if (!text) return null;

  const parts = text.split('@');
  if (parts.length < 8) return null;

  const [, apellidos, nombres, sexo, dni, , fechaNacimiento] = parts;

  if (!apellidos?.trim() || !nombres?.trim() || !/^\d{7,8}$/.test(dni || '')) return null;

  const fecha = dayjs(fechaNacimiento, 'DD/MM/YYYY', true);
  if (!fecha.isValid()) return null;

  return {
    apellidos: apellidos.trim(),
    nombres: nombres.trim(),
    sexo: SEXO_MAP[sexo] || 'noEspecificado',
    documentoNumero: dni,
    fechaNacimiento: fecha.toDate(),
  };
}
